import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ExtraOptions, NoPreloading, RouterModule} from '@angular/router';
import {FuseMockApiModule, FuseModule} from 'fuseui';
import { FuseConfigModule } from 'fuseui';
import { appConfig } from './core/config/app.config';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import {CoreModule} from "./core/core.module";
import {LayoutModule} from "marida";
import {mockApiServices} from "./mock-api";
import {HttpClient} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {MaridaModule} from "../../../../libs/marida/src/lib/marida.module";
import {ToastrModule} from "ngx-toastr";

const routerConfig: ExtraOptions = {
    preloadingStrategy       : NoPreloading,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        MaridaModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        // Core module of your application
        CoreModule,
        // Layout module of your application
        LayoutModule,

        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(), // ToastrModule added

        // Translate module
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
                deps: [HttpClient]
            }
        }),
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
